import React, { Component } from 'react';
import MyFrame from '../components/Frame';
import { Switch, Route, Redirect } from 'react-router-dom';
import { app } from "../app";
import '../css/skillTrain.css';
import STNotice from "./skillTrain/Notice";
import STSignUp from "./skillTrain/SignUp";
import MtList from "./skillTrain/MineTrainList";
import STIntroduce from "./skillTrain/Introduce";

function checkMenu(path) {
    let key = '4';
    switch (path) {
        case '/skillTrain/notice':
            key = '2';
            break;
        case '/skillTrain/mtList':
            key = '4';
            break;
        case '/skillTrain/introduce':
            key = '6';
            break;
    }
    return key;
}

class SkillTrain extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menu_key: checkMenu(props.location.pathname),
        };
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * 设置值
     * @param data
     */
    setData = (data) => app.setStateSync(this, data)

    componentWillReceiveProps(nextProps) {
        if (this.props.location.pathname !== nextProps.location.pathname) {
            this.setData({ menu_key: checkMenu(nextProps.location.pathname) })
        }
    }

    render() {
        let { menu_key } = this.state, rights = app.getData('rights'),
            menuList = [
                //{key: '1', text: '培训报名', link: '/skillTrain'},
                //{key: '2', text: '培训通知', link: '/skillTrain/notice'},
                { key: '4', text: '我的报名', link: '/skillTrain/mtList' },
                //{key: '6', text: '技能介绍', link: '/skillTrain/introduce'},
            ]
        return (
            <div>                
                <MyFrame className="skillTrain" history={this.props.history} menuList={menuList} menuSelectKey={menu_key} siderWidth="10rem">
                    <Switch>
                        {/*<Route exact path="/skillTrain/notice" component={STNotice}/>*/}
                        {/*<Route exact path="/skillTrain/mtList" component={MtList}/>*/}
                        {/*<Route exact path="/skillTrain/introduce" component={STIntroduce}/>*/}
                        {/*<Route exact path="/skillTrain" component={STSignUp}/>*/}
                        <Route exact path="/skillTrain" component={MtList} />
                        <Route render={() => <Redirect to="/skillTrain" />} />
                    </Switch>
                </MyFrame>
            </div>
        );
    }
}

export default SkillTrain;



// WEBPACK FOOTER //
// ./src/routes/SkillTrain.jsx